import React from "react"
import classNames from "classnames"

import { ICheckListViewActions, ITopic } from "../.."

import Topic from "./Topic"

export interface Props {
    containerElement: string
    contextMenuActions: ICheckListViewActions
    hasIndentation: boolean
    topics: ITopic[] | null
}

export const TopicList = ({
    containerElement,
    contextMenuActions,
    hasIndentation,
    topics,
}: Props): JSX.Element => {
    if (!topics || topics.length === 0) {
        return <></>
    }

    const classes = classNames("tw-flex tw-flex-col tw-gap-2", {
        "tw-pt-2": hasIndentation,
        "tw-pl-4": hasIndentation,
    })

    return (
        <div
            data-ft-component={containerElement}
            data-ft-count={topics.length}
            className={classes}
        >
            {topics.map((topic) => (
                <Topic
                    key={topic.id}
                    {...topic}
                    contextMenuActions={contextMenuActions}
                />
            ))}
        </div>
    )
}

export default TopicList
